import i18n from "@/i18n";

export default [
  {
    path: "/ki-pilot-theorie",
    name: "KiPilotTheorie",
    meta: {
      title: String(i18n.t("sidebar.ki_pilot_theorie")),
      trans: "sidebar.ki_pilot_theorie",
    },
    component: () => import(/* webpackChunkName: "ki-pilot-theorie" */ "@/views/Exam/KiPilotTheorie/KiPilotTheorie.vue"),
  },
];
